export const EVENT_SCOPE_KEY = "velora_active_event";
export const LEGACY_EVENT_ID = "velora-jdm-2026-09-13";
export const getEventId = () => localStorage.getItem(EVENT_SCOPE_KEY) || LEGACY_EVENT_ID;
export const eventDisplayName = event => event?.numero ? `${event.numero} · ${event.nome}` : event?.nome || "";
export const scopedUrl = url => {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set("context_event_id", getEventId());
    return parsed.toString();
};